import log from "loglevel";
import React, { useState, useEffect } from "react";
import * as constants from "Constants";
import MarkdownIt from "markdown-it";
import "react-markdown-editor-lite/lib/index.css";
import httpService from 'services/httpService.js';
import { Col, Container } from "react-bootstrap";

const AboutCourseStudent = ({ courseId }) => {
  log.log(courseId);
  const [description, setDescription] = useState(" ");
  const [startDate, setStartDate] = useState(null);
  const md = new MarkdownIt({ underline: true });
  let url = constants.base_url + "/courseware/api/courseinfo/" + courseId + "/";

  const fetchData = async () => {
    const response = await httpService.get(url);
    if (response.status == 200) {
      const { data } = response;
      setDescription(data.description);
      setStartDate(data.start_time);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderMarkdown = (markdown) => {
    if (!markdown) return "";
    return md.render(markdown);
  };

  const renderContentStrict = (content) => {
    if (!content) return "";

    const trimmed = content.trim();

    const hasProperHTMLStructure = /<[^>]+>[\s\S]*<\/[^>]+>/.test(trimmed) ||
      /<[^>]+\s*\/>/.test(trimmed); // self-closing tags

    if (hasProperHTMLStructure) {
      return content;
    } else {
      return md.render(content);
    }
  };

  return (
    <div className="bg-white">
      <Container className="my-0 my-md-4" fluid>
        <Col xs={12} className="p-1 px-md-2">
          {
            !description ?
              <p className="text-muted">
                <small><em>No description available.</em></small>
              </p> :
              <div className="text-break w-100 overflow-hidden lh-base" dangerouslySetInnerHTML={{ __html: renderContentStrict(description) }} />
          }
        </Col>
        {/* <Col xs={12}>
          <h5>Course Start Date</h5>
          <div>
            {moment(startDate).format("MMM DD YYYY")}
          </div>
        </Col> */}
      </Container>
    </div>
  );
};

const styles = {
  outerbox: {
    border: "1px solid #ccc",
    marginLeft: 15,
    padding: 20,
  },
  headerStyle: {
    color: "grey",
    display: "inline",
  },
  buttonbox: {
    padding: "0 20",
  },
};
export default AboutCourseStudent;
